var _ = require('underscore');
var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var portalSurveyResponseExtService = require('./../urls').portalSurveyResponseExtService;

/**
 * Model for PortalSurveyResponseDTOs.
 * Represents a survey definitions with appointment specific appointmentExternalId, recipientCode,
 * and surveyResponseId information.
 *
 * @class PortalSurveyResponseModel
 * @constructor
 */
module.exports = TorsoNestedModel.extend({
  /**
   * @method url
   * @return {String} url for survey
   */
  url: function() {
    // check that surveyName and appointmentId are both defined
    if (_.isUndefined(this.get('surveyName'))) {
      throw new ReferenceError('Cannot create generate url for PreRegSurveyDefinitionModel. surveyName is undefined');
    } else if (_.isUndefined(this.get('appointmentExternalId'))) {
      throw new ReferenceError('Cannot create generate url for PreRegSurveyDefinitionModel. appointmentExternalId is undefined');
    }

    return portalSurveyResponseExtService + '/appointment/' + this.get('appointmentExternalId') + '/survey/' + encodeURIComponent(this.get('surveyName'));
  },

  /**
   * @method isAnonymous
   * @return {Boolean}   false because pre-reg responses should never be anonymous
   */
  isAnonymous: function() {
    return false;
  }
});
